import { Pipe, PipeTransform } from '@angular/core';
import { Supplier } from '../../classes/supplier';

@Pipe({
  name: 'supplierCfFilter',
  pure: false
})
export class SupplierCfFilterPipe implements PipeTransform {

  transform(supplierList: Array<Supplier>, filterValue: string): any {
    if (!supplierList || !filterValue) {
      return supplierList;
    }
    const normalizedFilterValue = filterValue.toLowerCase().trim();
    return supplierList.filter(supplier =>
      (supplier.CF || '').toLowerCase().indexOf(normalizedFilterValue) !== -1
    );
  }

}
